// FIXED BASE PATH HERE (ONE PLACE ONLY)
const assetsContext = require.context(
    "./",        // base path: src/components/assets
    true,        // include subfolders
    /\.(png|jpe?g|svg|webp)$/ // allowed files
  );
  
  export const getAsset = (relativePath) => {
    try {
      return assetsContext(`./${relativePath}`);
    } catch (error) {
      console.error("Asset not found:", relativePath);
      return "";
    }
  };
  